import { Box, Flex } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { IconButton } from 'src/design-system/IconButton';
import { Button } from 'src/design-system/Button';
import { Tooltip } from 'src/design-system/Tooltip';

type FlowNavigationFooterProps = {
  onBack: () => void;
  onAction: () => void;
  actionLabel?: string;
  actionDisabled?: boolean;
  actionLoading?: boolean;
  actionDisabledTooltip?: string;
};

export function FlowNavigationFooter({
  onBack,
  onAction,
  actionLabel = 'Continue',
  actionDisabled,
  actionLoading,
  actionDisabledTooltip,
}: FlowNavigationFooterProps) {
  return (
    <Flex gap="sm" align="center">
      <IconButton size={48} bg="gray.1" c="gray.9" onClick={onBack}>
        <IconArrowLeft size={20} />
      </IconButton>
      <Tooltip
        label={actionDisabledTooltip}
        disabled={!actionDisabled || !actionDisabledTooltip}
        withArrow
      >
        <Box>
          <Button
            variant="primary"
            px={44}
            disabled={actionDisabled}
            loading={actionLoading}
            onClick={onAction}
          >
            {actionLabel}
          </Button>
        </Box>
      </Tooltip>
    </Flex>
  );
}
